<template>
  <div class="order-contain">
    <div class="order-sub-title-sty">
      <h5>請確認或填寫個人資料</h5>
    </div>
    <div class="form-group">
        <label for="phone">手機號碼</label>
        <input type="text" class="form-control re-order-input-sty" id="phone" name="phone" value="" maxlength="10" placeholder="手機" v-model="phone">
        <div id="order-phone-error-msg" class="rs-order-error-tip"></div>
    </div>
    <div class="form-group">
      <label for="alternate_phone">備用電話 (選填)</label>
      <input type="text" class="form-control re-order-input-sty" id="alt_phone" name="alt_phone" maxlength="10" placeholder="建議市話" v-model="alternate_phone">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="name">姓名</label>
      <input type="text" class="form-control re-order-input-sty" id="name" name="name" value="" maxlength="100" :state="false" v-model="name">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="contact_times">您方便接聽電話的時段</label><span class="icon-btn-sty def" @click="addOtherContactTime"><i class="rs-icon-default rs-icon-plus rs-icon-unitsize"></i></span>
    </div>
    <b-form-group v-for="(contactTime, index) in contact_times" :key="index">
      <b-form-select
        v-model="contactTime.start"
        :options="timeArray"
        class="order-input-col4 re-order-input-sty"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>時段從</b-form-select-option>
        </template>
      </b-form-select>
      <b-form-select
        v-model="contactTime.end"
        :options="timeArray"
        class="order-input-col4 re-order-input-sty"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>到</b-form-select-option>
        </template>
      </b-form-select>
      <div class="order-col4">
        <span class="icon-btn-sty dang" @click="removeContactTime(index)"><i class="rs-icon-default rs-icon-minus rs-icon-unitsize"></i></span>
      </div>
    </b-form-group>
    <div class="form-group">
      <label for="birth">生日</label>
      <b-form-group>
        <input type="number" class="order-input-col4 re-order-input-sty" id="birthY" name="birthY" v-model="birthY" placeholder="西元年 (ex. 1980)">
        <input type="number" class="order-input-col4 re-order-input-sty" id="birthM" name="birthM" v-model="birthM" placeholder="月 (ex. 1)">
        <input type="number" class="order-input-col4 re-order-input-sty" id="birthD" name="birthD" v-model="birthD" placeholder="日 (ex. 1)">
      </b-form-group>
      <span class="order-info-hint">* 使用服務超過3次以上客戶，享生日優惠</span>
    </div>
    <!-- <div class="form-group"> -->
      <!-- <div>選擇服務等級 (請勾選至少一項，可多選)</div> -->
      <!-- <div>服務費用</div>
      <div class="row">
        <div class="col-sm-4" v-for="(staff_level, index) in dropDownObj.staff_levels" :key="index">
          <input type="checkbox" :id="`staff_level_${ staff_level.id }`" :value="staff_level.id" v-model="staff_levels" checked disabled="disabled">
          <label :for="`staff_level_${ staff_level.id }`">{{ staff_level.label }} <span> ( {{staff_level.price}} 元 / 分鐘 )</span></label>
        </div>
      </div> -->
      <!-- <div>目前服務計費</div>
      <div class="row">
        <div class="col-sm-12">
          <span>服務員(8元/分鐘)</span>
        </div>
      </div> -->
    <!-- </div> -->
    <div class="form-group">
      <label for="city">縣市 (選項以外區域請在地址欄位填寫完整地址)</label>
      <select class="form-control re-order-input-sty" id="countries" name="countries" data-orig-value="" v-model="country_id">
        <option selected="selected" disabled="">請選擇</option>
        <option v-for="(country, index) in dropDownObj.countries" :key="index" :value="country.id">{{ country.name }}</option>
      </select>
      <div id="contries_error_area" class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="district">鄉鎮區</label>
          <select class="form-control re-order-input-sty" id="district" name="district" data-orig-value="" v-model="city_id">
            <option selected="selected" disabled="">請選擇</option>
            <option v-for="(city, index) in this.citiesArray" :key="index" :value="city.id">{{ city.label }}</option>
          </select>
          <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="address">地址</label>
      <input type="text" class="form-control re-order-input-sty" id="address" name="address" value="" maxlength="1000" v-model="address1">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="community_building">社區或大樓名稱 (選填)</label>
      <input type="text" class="form-control re-order-input-sty" id="community_building" name="community_building" value="" maxlength="100" v-model="address2">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="appointment_type" id="service_type_label">服務類型</label>
      <div class="order-radio-area-sty row">
        <div class="col-sm-4" v-for="(service_type, index) in dropDownObj.service_types" :key="index">
          <input type="radio" :id="`service_type_${ service_type.id }`" :value="service_type.id" v-model="service_type_id">
          <label :for="`service_type_${ service_type.id }`">{{ service_type.label }}</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="building_types">清潔建築類型</label>
      <div class="order-radio-area-sty row">
        <div class="col-sm-4" v-for="(budilding_info, index) in dropDownObj.building_types" :key="index">
          <input type="radio" :id="`building_type_${ budilding_info.id }`" :value="budilding_info.id" v-model="building_type">
          <label :for="`building_type_${ budilding_info.id }`">{{ budilding_info.label }}</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="building_square">室內坪數</label>
      <input type="text" class="form-control re-order-input-sty" id="building_square" name="building_square" placeholder="例如: 12.2" value="" maxlength="100" v-model="building_square">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="cleaning_range">清潔範圍 </label>
      <!-- <input type="text" class="form-control" id="cleaning_range" name="cleaning_range" placeholder="例如: 廁所、浴廁......" value="" maxlength="100" v-model="cleaning_range">
      <div class="help-block with-errors"></div> -->
      <b-form-textarea
        id="cleaning_range"
        v-model="cleaning_range"
        placeholder="例如: 2浴廁、1廚房、整棟地板"
        rows="3"
        max-rows="6"
        lazy-formatter
        class="re-order-input-sty"
      ></b-form-textarea>
    </div>
    <hr>
    <div class="order-sub-title-sty">
      <h5>預約日期</h5>
    </div>
    <div class="form-group">
    </div>
    <b-form-group label="選擇日期">
      <b-form-datepicker id="appointment_date" v-model="appointment_date"  :min="mindate" :max="maxdate" class="mb-2 re-order-input-sty"></b-form-datepicker>
    </b-form-group>
    <b-form-group
      id="appointment_period_id"
      label="選擇時間:"
      label-for="appointment_period_id"
      v-if="isShowAppointmentOption">
      <b-form-select
        label="選擇時間:"
        v-model="appointment_period_id"
        :options="currentApointmentTimeArray"
        class="mb-3 re-order-input-sty"
        value-field="id"
        text-field="label"
      >
      </b-form-select>
    </b-form-group>
    <b-form-group
      id="tpspan"
      label="預計時間:"
      label-for="tpspan"
      v-if="isShowAppointmentOption">
      <b-form-select
        label="預計時間:"
        v-model="appointment_type_id"
        :options="currentApointmentTypesArray"
        class="mb-3 re-order-input-sty"
        value-field="id"
        text-field="label"
      >
      </b-form-select>
    </b-form-group>
    <div class="order-sub-title-sty">
      <h5>預約服務</h5>
    </div>
    <div class="form-group">
      <label for="staff_number">需要幾位職人? (1-10)</label>
      <input class="form-control re-order-input-sty" id="staff_number" name="staff_number" value="1" required="" v-model="staff_count">
      <div class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <div>服務員性別指定</div>
      <div class="order-radio-area-sty row">
        <div class="col-sm-4" v-for="(service_gender, index) in service_genders" :key="index">
          <input type="radio" :id="`service_gender_${ service_gender.id }`" :value="service_gender.id" v-model="gender">
          <label :for="`service_gender_${ service_gender.id }`">{{ service_gender.label }}</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div>是否需要自備吸塵器</div>
      <div class="order-radio-area-sty row">
          <div class="col-sm-6">
            <input type="radio" id="spec_clenaer_yes" value="1" v-model="spec_clenaer">
            <label for="spec_clenaer_yes">是</label>
        </div>
        <div class="col-sm-6">
            <input type="radio" id="spec_clenaer_no" value="0" v-model="spec_clenaer">
            <label for="spec_clenaer_no">否</label>
        </div>
      </div>
      <div class="rs-order-tip-sty">
        ※ 人員攜帶的吸塵器為輕巧型吸塵器，如果自身家裡有的話建議用家裡的，吸力會較強。
      </div>
    </div>
    <div class="form-group">
      <div>是否需要除膠</div>
      <div class="order-radio-area-sty row">
          <div class="col-sm-6">
            <input type="radio" id="spec_glue_rm_yes" value="1" v-model="spec_glue_rm">
            <label for="spec_glue_rm_yes">是</label>
        </div>
        <div class="col-sm-6">
            <input type="radio" id="spec_glue_rm_no" value="0" v-model="spec_glue_rm">
            <label for="spec_glue_rm_no">否</label>
        </div>
      </div>
      <div class="rs-order-tip-sty">
        ※ 除膠耗費時間較多，建議傳殘膠狀況照片給線上客服，協助您判斷。
      </div>
    </div>
    <!-- <div class="form-group">
      <div>是否需要專業收納(空間整體規劃)</div>
      <div class="order-radio-area-sty row">
          <div class="col-sm-6">
            <input type="radio" id="spec_storage_yes" value="1" v-model="spec_storage">
            <label for="spec_storage_yes">是</label>
        </div>
        <div class="col-sm-6">
            <input type="radio" id="spec_storage_no" value="0" v-model="spec_storage">
            <label for="spec_storage_no">否</label>
        </div>
      </div>
    </div> -->
    <div class="form-group">
      <div>是否有寵物</div>
      <div class="order-radio-area-sty row">
          <div class="col-sm-6">
            <input type="radio" id="has_pet_yes" value="1" v-model="has_pet">
            <label for="has_pet_yes">是</label>
        </div>
        <div class="col-sm-6">
            <input type="radio" id="has_pet_no" value="0" v-model="has_pet">
            <label for="has_pet_no">否</label>
        </div>
      </div>
      <div class="rs-order-tip-sty">
        ※ 如果寵物對陌生人較敏感，建議隔一塊區塊給寵物活動，讓寵物可以安心、放鬆。
      </div>
    </div>
    <!-- <div class="form-group">
      <div>是否需要免費安排小助手協助</div>
      <div class="order-radio-area-sty row">
          <div class="col-sm-6">
            <input type="radio" id="spec_rookie_yes" value="1" v-model="spec_rookie">
            <label for="spec_rookie_yes">是</label>
        </div>
        <div class="col-sm-6">
            <input type="radio" id="spec_rookie_no" value="0" v-model="spec_rookie">
            <label for="spec_rookie_no">否</label>
        </div>
      </div>
    </div> -->
    <div class="form-group">
      <label for="note">額外備註</label>
        <b-form-textarea
        id="note"
        v-model="note"
        placeholder="例如: 1. 摺衣服 2.清潔劑不可使用 3.可以使用廚房抹布 ...... 等等"
        rows="5"
        max-rows="6"
        lazy-formatter
        class="re-order-input-sty"
      ></b-form-textarea>
      <div class="help-block with-errors"></div>
    </div>
    <b-form-group label="推薦人電話" v-if="!dropDownObj.recommender_close">
        <b-form-input id="recomend_phone_val" class="re-order-input-sty" v-model="recommend_phone" placeholder="ex. 0912345678"  maxlength="10"></b-form-input>
    </b-form-group>
    <b-form-group label="優惠碼">
        <b-form-input id="coupon_code" class="re-order-input-sty" v-model="coupon_code"></b-form-input>
    </b-form-group>
    <hr>
    <div class="order-footer-contain text-right">
      <b-button
          class="text-white"
          variant="info"
          size="lg"
          @click="checkOrderInput"
          >送出
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OrderContent',
  props: {
    dropDownObj: {
      staff_levels: Array,
      countries: Array,
      appointment_periods: Array,
      appointment_types: Array,
      service_types: Array,
      recommender_close: Boolean
    }
  },
  data () {
    return {
      mindate: '',
      maxdate: '',
      phone: '',
      alternate_phone: '',
      name: '',
      birthY: null,
      birthM: null,
      birthD: null,
      birth: '',
      birthDMax: 31,
      staff_levels: [],
      staff_count: 1,
      country_id: '',
      city_id: '',
      address1: '',
      address2: '',
      appointment_date: '',
      appointment_period_id: '',
      appointment_type_id: '',
      gender: '',
      service_genders: [{ id: 2, label: '無指定' }, { id: 0, label: '男' }, { id: 1, label: '女' }],
      service_type_id: '',
      spec_clenaer: false,
      spec_glue_rm: false,
      spec_storage: false,
      has_pet: false,
      spec_rookie: false,
      building_type: 1,
      building_square: '',
      cleaning_range: '',
      recommend_phone: null,
      coupon_code: null,
      contact_times: [{
        start: null,
        end: null
      }],
      note: '',
      citiesArray: [],
      currentApointmentTimeArray: [],
      currentApointmentTypesArray: [],
      isShowAppointmentOption: false,
      timeArray: [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
    }
  },
  watch: {
    name (val) {
      if (val) {
        this.removeFocus('name')
      }
    },
    phone (val) {
      const target = this.$el.querySelector('#phone')
      const errorWrap = this.$el.querySelector('#order-phone-error-msg')
      if (val) {
        if (!isNaN(val)) {
          if (val === '886') {
            this.phone = '09'
          }
          this.removeFocus('phone')
        } else {
          if (val === '+886') {
            this.phone = '09'
          } else {
            this.phone = val.replace(/\D/g, '')
          }
        }
        if (this.phone.length < 10) {
          if (target) {
            if (!target.classList.contains('order-input-danger')) {
              target.classList.add('order-input-danger')
            }
            if (errorWrap) {
              errorWrap.textContent = '目前電話低於10碼,請確認輸入是否正確，若為正確請忽略此提示，提示訊息將於稍後消失。'
            }
          }
          setTimeout(() => {
            if (target) {
              if (target.classList.contains('order-input-danger')) {
                target.classList.remove('order-input-danger')
              }
              if (errorWrap) {
                errorWrap.textContent = ''
              }
            }
          }, 3000)
        } else {
          if (target) {
            if (target.classList.contains('order-input-danger')) {
              target.classList.remove('order-input-danger')
            }
            if (errorWrap) {
              errorWrap.textContent = ''
            }
          }
        }
      } else {
        if (target) {
          if (!target.classList.contains('order-input-danger')) {
            target.classList.add('order-input-danger')
          }
          if (errorWrap) {
            errorWrap.textContent = '手機號碼不能為空，請輸入手機號碼'
          }
        }
      }
    },
    staff_count (val) {
      var intVal = parseInt(val)
      if (!isNaN(val) && intVal > 0) {
        if (val > 10) {
          this.$bvToast.toast('人數最多10位', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
          this.staff_count = 10
        }
        this.removeFocus('staff_number')
      } else {
        if (isNaN(val)) {
          this.addFocus('staff_number')
          this.$bvToast.toast('此欄位只能輸入數字', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        } else {
          this.$bvToast.toast('人數必須大於0', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
      }
    },
    address1 (val) {
      if (val) {
        this.removeFocus('address')
      }
    },
    country_id (val) {
      var currentCountry
      if (val) {
        this.removeFocus('countries')
        currentCountry = this.dropDownObj.countries.find((country) => {
          var isTarget = false
          if (country.id === val) {
            isTarget = true
          }
          return isTarget
        })
        this.citiesArray = currentCountry.cities
        this.city_id = ''
      }
    },
    city_id (val) {
      if (val) {
        this.removeFocus('district')
      }
    },
    service_type_id (val) {
      if (val) {
        this.removeFocus('service_type_label')
      }
    },
    appointment_date (val) {
      if (val) {
        this.isShowAppointmentOption = true
        this.currentApointmentTimeArray = this.dropDownObj.appointment_periods
        this.removeFocus('appointment_date__outer_')
      } else {
        this.isShowAppointmentOption = false
      }
    },
    appointment_period_id (val) {
      if (val !== '') {
        this.removeFocus('appointment_period_id__BV_label_')
        if (val >= 24) {
          this.currentApointmentTypesArray = [this.dropDownObj.appointment_types[0]]
        } else {
          this.currentApointmentTypesArray = this.dropDownObj.appointment_types
        }
      } else {
        this.currentApointmentTypesArray = []
        this.appointment_types = ''
      }
    },
    appointment_type_id (val) {
      if (val) {
        this.removeFocus('tpspan__BV_label_')
      }
    },
    birthY (value) {
      var intV = value ? parseInt(value) : 0
      var valArray = intV ? String(intV).split('') : []
      var finalVal
      if (intV) {
        if (valArray.length > 4) {
          valArray.splice(4)
        }
        finalVal = parseInt(valArray.join(''))
      } else {
        if (intV === 0) {
          finalVal = 0
        }
      }
      this.birthY = finalVal
    },
    birthM (value) {
      var valArray = value ? String(value).split('') : []
      var finalVal
      if (value) {
        if (valArray.length > 2) {
          valArray.splice(2)
        }
        finalVal = parseInt(valArray.join(''))
        if (finalVal <= 12) {
          if (finalVal <= 0) {
            this.$bvToast.toast('數字請直接輸入1至12數字中您生日的月份，ex. 如三月即輸入3', {
              title: '',
              toaster: 'b-toaster-top-center',
              variant: 'danger',
              solid: true
            })
            finalVal = 1
          }
        } else {
          this.$bvToast.toast('數字請直接輸入1至12數字中您生日的月份，ex. 如三月即輸入3', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
          finalVal = 12
        }
        this.birthM = finalVal
        switch (finalVal) {
          case 2:
            this.birthDMax = 29
            break
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12:
            this.birthDMax = 31
            break
          default:
            this.birthDMax = 30
        }
        console.log(finalVal)
      }
    },
    birthD (value) {
      var valArray = value ? String(value).split('') : []
      var finalVal
      if (value) {
        if (valArray.length > 2) {
          valArray.splice(2)
        }
        finalVal = parseInt(valArray.join(''))
        if (finalVal <= this.birthDMax) {
          if (finalVal <= 0) {
            finalVal = 1
          }
        } else {
          finalVal = this.birthDMax
        }
        this.birthD = finalVal
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.mindate = this.getCorrectDate('min')
      this.maxdate = this.getCorrectDate('max')
    })
  },
  methods: {
    getCorrectDate (type) {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const maxminDate = new Date('2023/1/19')
      const maxminDateTimestamp = maxminDate.valueOf()
      var day = now.getDate()
      var month = now.getMonth()
      var findalDate = new Date(today)
      var currentTimeStamp
      switch (type) {
        case 'min':
          day++
          findalDate.setDate(day)
          break
        case 'max':
          month += 2
          findalDate.setMonth(month)
          currentTimeStamp = findalDate.valueOf()
          if (maxminDateTimestamp > currentTimeStamp) {
            findalDate = maxminDate
          }
          break
      }
      return findalDate
    },
    scrollAndFocusOnFrom (id) {
      const idStr = '#' + id
      const target = this.$el.querySelector(idStr)
      if (target) {
        if (!target.classList.contains('order-input-danger')) {
          target.classList.add('order-input-danger')
        }
        target.scrollIntoView()
      }
    },
    addFocus (id) {
      const idStr = '#' + id
      const target = this.$el.querySelector(idStr)
      if (target) {
        if (!target.classList.contains('order-input-danger')) {
          target.classList.add('order-input-danger')
        }
      }
    },
    removeFocus (id) {
      const idStr = '#' + id
      const target = this.$el.querySelector(idStr)
      if (target) {
        if (target.classList.contains('order-input-danger')) {
          target.classList.remove('order-input-danger')
        }
      }
    },
    submitOrderForm () {
      const self = this
      const userId = this.$store.getters.getUserId
      const postUrl = this.$apiDoc.customerUrl + userId + this.$apiDoc.apiPostOrder
      var birthArray = []
      var birthYStr = ''
      var birthMStr = ''
      var birthDStr = ''
      var apiOptions = {
        name: this.name,
        phone: this.phone,
        alternate_phone: this.alternate_phone,
        staff_levels: (this.staff_levels.length === 0) ? [this.dropDownObj.staff_levels[0].id] : this.staff_levels,
        staff_count: isNaN(this.staff_count) ? 1 : parseInt(this.staff_count),
        country_id: this.country_id,
        city_id: this.city_id,
        address1: this.address1,
        address2: this.address2,
        appointment_date: new Date(this.appointment_date).toISOString(),
        appointment_period_id: this.appointment_period_id,
        appointment_type_id: this.appointment_type_id,
        note: this.note,
        reference_phone: this.reference_phone,
        service_type_id: this.service_type_id,
        gender: this.gender,
        spec_clenaer: this.$toolDoc.turnToBoolean(this.spec_clenaer),
        spec_glue_rm: this.$toolDoc.turnToBoolean(this.spec_glue_rm),
        spec_storage: this.$toolDoc.turnToBoolean(this.spec_storage),
        has_pet: this.$toolDoc.turnToBoolean(this.has_pet),
        spec_rookie: this.$toolDoc.turnToBoolean(this.spec_rookie),
        building_type: this.building_type,
        building_square: this.building_square,
        cleaning_range: this.cleaning_range
      }
      var errorMsg = this.$toolDoc.defaultErrorMsg
      if (this.birthY && this.birthM && this.birthD) {
        birthYStr = String(this.birthY)
        birthMStr = this.$toolDoc.checkSingleNumToStr(this.birthM)
        birthDStr = this.$toolDoc.checkSingleNumToStr(this.birthD)
        if (birthYStr.length === 4 && birthMStr.length === 2 && birthDStr.length === 2) {
          birthArray.push(birthMStr)
          birthArray.push(birthDStr)
          birthArray.push(birthYStr)
          this.birth = birthArray.join('/')
        }
      }
      if (this.birth && birthArray.length === 3) {
        apiOptions.birth = new Date(this.birth).toISOString()
      }
      if (this.contact_times && this.contact_times.length > 0) {
        apiOptions.contact_times = this.$toolDoc.arrangeContactTimeArray(this.contact_times, true)
      }

      if (!this.dropDownObj.recommender_close && this.recommend_phone) {
        apiOptions.recommend_phone = this.recommend_phone
      }

      if (this.coupon_code) {
        apiOptions.coupon_code = this.coupon_code
      }
      if (userId) {
        this.$api.post(postUrl, apiOptions).then((resp) => {
          alert('恭喜預約成功')
          self.$liff.closeWindow()
        }).catch((errorInfo) => {
          console.log('errorInfo:', errorInfo)
          console.log(self.$toolDoc)
          errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
          alert(errorMsg)
          self.$liff.closeWindow()
        })
      } else {
        alert(errorMsg)
        this.$liff.closeWindow()
      }
    },
    checkOrderInput () {
      const self = this
      if (this.name && this.phone && this.address1 && this.appointment_date && this.country_id && this.city_id && this.appointment_period_id && this.appointment_type_id && this.service_type_id && this.staff_count > 0) {
        try {
          self.submitOrderForm()
        } catch (e) {
          console.log(e)
          self.setDebugInfo('CreateOrder', e, true)
        }
      } else {
        if (this.staff_count === 0 || this.staff_count > 10 || isNaN(this.staff_count)) {
          this.scrollAndFocusOnFrom('staff_number')
        }
        if (!this.appointment_type_id) {
          this.scrollAndFocusOnFrom('tpspan__BV_label_')
        }
        if (!this.appointment_period_id) {
          this.scrollAndFocusOnFrom('appointment_period_id__BV_label_')
        }
        if (!this.appointment_date) {
          this.scrollAndFocusOnFrom('appointment_date__outer_')
        }
        if (!this.service_type_id) {
          this.scrollAndFocusOnFrom('service_type_label')
        }
        if (!this.address1) {
          this.scrollAndFocusOnFrom('address')
        }
        if (!this.city_id) {
          this.scrollAndFocusOnFrom('district')
        }
        if (!this.country_id) {
          this.scrollAndFocusOnFrom('countries')
        }
        if (!this.name) {
          this.scrollAndFocusOnFrom('name')
        }
        if (!this.phone) {
          this.scrollAndFocusOnFrom('phone')
        }
        this.$bvToast.toast('紅字或紅框處為必填項目，麻煩請確實填寫，謝謝!', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      }
    },
    removeContactTime (index) {
      this.contact_times.splice(index, 1)
    },
    addOtherContactTime () {
      var newTime = {
        start: null,
        end: null
      }
      this.contact_times.push(newTime)
    },
    setDebugInfo (type, val, ispop) {
      // const self = this
      const setLogApi = this.$apiDoc.apiSetLog
      const userId = this.$store.getters.getUserId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var option = {}
      var logMsg = '[Debug][Reception]'
      if (type) {
        logMsg += '[' + type + '][errorInfo]: '
      }
      logMsg += JSON.stringify({ message: val.message, stack: val.stack })
      option.err = logMsg
      option.line_user_id = userId
      this.$api.post(setLogApi, option).then((resp) => {
        if (resp.result) {
          if (ispop) {
            alert(errorMsg)
          }
        }
      }).catch((errorInfo) => {
        errorMsg += '[errorInfo]:' + JSON.stringify(errorInfo)
        if (ispop) {
          alert(errorMsg)
        } else {
          console.log(errorMsg)
        }
      })
    }
  }
}
</script>
